import hoistNonReactStatic from 'hoist-non-react-statics';
import React, { Component } from 'react';
import { FocusState } from './focusState';
import { handleKeyChange } from '../HandleKeys';
import { processFocusChange } from './process-focus-change';
import { processKeyEvent } from './process-focus-key-event';
import { setGridBreakpoints } from '../SetGridBreakpoints';
import getDisplayName from '../../../utils/getDisplayName';

export function handleFocus(options = { }) {
    return WrappedComponent => {
        const { shouldUpdate } = options;

        const wrappedDisplayName = `HandleFocusView(${getDisplayName(WrappedComponent)})`;

        class HandleFocusView extends Component {
            static displayName = wrappedDisplayName;
            static WrappedComponent = WrappedComponent;
            static getFocusState = () => new FocusState();

            constructor() {
                super();
                this.state = { focusIndex: -1 };
            }

            componentDidMount() {
                let index = this.state.focusIndex;

                if (this.focusState.getSelectedIndex() !== this.state.focusIndex) {
                    index = this.focusState.getSelectedIndex();
                    // eslint-disable-next-line react/no-did-mount-set-state
                    this.setState({ focusIndex: index });
                } else if (index > 0) {
                    this.updateFocusedItem(index);
                }
            }

            updateFocusedItem(nextIndex, currentIndex) {
                if (this.props.isMobileBreakpoint()) {
                    return;
                }

                processFocusChange({
                    focusState: this.focusState,
                    nextIndex,
                    currentIndex,
                });
            }

            shouldComponentUpdate(nextProps, nextState) {
                if (nextState.focusIndex !== this.state.focusIndex) {
                    this.updateFocusedItem(nextState.focusIndex, this.state.focusIndex);
                }

                return !shouldUpdate || shouldUpdate(this.props, nextProps);
            }

            componentDidUpdate() {
                this.updateFocusedItem(this.state.focusIndex);
            }

            render() {
                this.focusState = new FocusState(state => this.setState(state));

                return (
                    <WrappedComponent
                        focusState={this.focusState}
                        {...this.props}
                    />
                );
            }

            onKeyChange(event) {
                processKeyEvent({
                    event,
                    focusState: this.focusState,
                    setState: s => this.setState(s),
                    state: this.state,
                    nextTab: this.props.nextTab ? this.props.nextTab(this.props) : null,
                    previousTab: this.props.previousTab ? this.props.previousTab(this.props) : null,
                });
            }
        }

        hoistNonReactStatic(HandleFocusView, WrappedComponent);

        return setGridBreakpoints()(
            handleKeyChange({ keyChangeType: 'keydown' })(
                HandleFocusView
            )
        );
    };
}
